import { css, Theme } from '@emotion/react';

export const scrollbar = (theme: Theme) => css`
  &::-webkit-scrollbar {
    width: 4px;
    background-color: ${theme.colors.DarkBlue};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.Gray};
    border-radius: 10px;
  }
`;
